import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import Button from "../../shared/button/Btn";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { showModal } from "../../../features/modal/modalSlice";
import { useScrollLock } from "../../../hooks/useScrollLock";
import PageTopTitle from "../../shared/PageTopTitle";
import { adminUpdateDocumentTruck } from "../../../features/admin2/admin2Slice";
import { useState } from "react";
import question from "../../../images/svg/question.svg"

const Container = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 100;

  .modal {
    width: auto;
    height: 700px;
    color: ${({ theme }) => theme.mainTextColor};
    background-color: ${({ theme }) => theme.mainBgColor};
    border-radius: 10px;
    padding-block: 20px;
    overflow: auto;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    .content {
      padding: 20px;
      h3{
        margin-bottom: 20px;
      }
      .belge-list{
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 20px;
          .belge-item{
            display: flex;
            flex-direction: column;
            width: 485px;
            height: 420px;  
            border-radius: 10px;
            padding: 0 20px;
            background-color: ${({ theme }) => theme.secondaryBgColor};

            .belge-top{
              width: 100%;
              height: 40px;
              display: flex;
              align-items: center;
              font-size: 16px;
              padding: 10px 0;
              font-weight: var(--font-weight-lg);
              border-bottom: 1px solid ${({theme})=> theme.mainBorderColor};
            }
            .belge-img{
              width: 100%;
              height: calc(100% - 100px);
              object-fit: cover;
            }

            .belge-bottom{
              width: 100%;
              height: 60px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              border-top: 1px solid ${({theme})=> theme.mainBorderColor};
                .file-input-label{
                  width: auto;
                  padding: 0 15px;
                  line-height: 40px;
                  text-align: center;
                  height: 40px;
                  color: ${({ theme }) => theme.mainTextColor};
                  border-radius: 10px;
                  font-weight: var(--font-weight-lg);
                  font-size: 16px;
                  border: 1px solid;
                  cursor: pointer;
                  border-color: ${({ theme }) => theme.contrastColor};
                }
                .file-name{
                  font-weight: var(--font-weight-md);
                  font-size: 14px;
                }

                .file-input{
                  display: none;
                }
            }
          }
        }
    }
    .btn {
      padding-inline: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      button {
        margin-inline: 10px;
      }
    }
  }
`;

const AdminAraclarBelgeIslemler = () => {
  const { modalLocation } = useSelector((state) => state.modal);
  const { selectAdminArac, adminTruckDocs } = useSelector((state) => state.admin2);
  const dispatch = useDispatch();
  const location = useLocation();
  const { lockScroll, unlockScroll } = useScrollLock();

  //! görsel states
  const [ruhsat, setRuhsat] = useState("")
  const [tasitKarti, setTasitKarti] = useState("")
  const [saseFoto, setSaseFoto] = useState("")
  const [trafikSigortaPolicesi, setTrafikSigortaPolicesi] = useState("")
  const [yukSigortaPolicesi, setYukSigortaPolicesi] = useState("")
  const [aracFotoOndenSuruculu, setAracFotoOndenSuruculu] = useState("")
  const [aracFotoOnden, setAracFotoOnden] = useState("")
  const [aracFotoYandan, setAracFotoYandan] = useState("")
  const [aracFotoArkadan, setAracFotoArkadan] = useState("")

  const url = "https://egeyurtgrupbucket.s3.eu-north-1.amazonaws.com/Images/"

  // //! bu modal açıldığnda ekran ı lock lamak için
  useEffect(() => {
    lockScroll();

    return () => {
      unlockScroll();
    };
  }, [lockScroll, unlockScroll]);

  // //! bu başka bir sayfaya geçildiğinde modal ı kapatmak için
  useEffect(() => {
    if (location.pathname !== modalLocation) {
      dispatch(showModal(null));
    }
  }, [dispatch, location.pathname, modalLocation]);


  const handleRuhsatSubmit = () => {
    if(ruhsat){
      const updatedTruckDoc = {
        userName: selectAdminArac.truckPlateNumber,
        documentType: "ruhsat",
        imageFile: ruhsat
    }
    dispatch(adminUpdateDocumentTruck(updatedTruckDoc))
    }
  }

  const handleTasitKartiSubmit = () => {
    if(tasitKarti){
      const updatedTruckDoc = {
        userName: selectAdminArac.truckPlateNumber,
        documentType: "TasitKartiPhoto",
        imageFile: tasitKarti
    }
    dispatch(adminUpdateDocumentTruck(updatedTruckDoc))
    }
  }

  const handleSaseFotoSubmit = () => {
    if(saseFoto){
      const updatedTruckDoc = {
        userName: selectAdminArac.truckPlateNumber,
        documentType: "SasePhoto",
        imageFile: saseFoto
    }
    dispatch(adminUpdateDocumentTruck(updatedTruckDoc))
    }
    
  }

  const handleTrafikSigortaPolicesiSubmit = () => {
    if(trafikSigortaPolicesi){
      const updatedTruckDoc = {
        userName: selectAdminArac.truckPlateNumber,
        documentType: "TrafikSigortaPolicePohoto",
        imageFile: trafikSigortaPolicesi
    }
    dispatch(adminUpdateDocumentTruck(updatedTruckDoc))
    }
    
  }

  const handleYukSigortaPolicesiSubmit = () => {
    if(yukSigortaPolicesi){
      const updatedTruckDoc = {
        userName: selectAdminArac.truckPlateNumber,
        documentType: "YukSigortaPolicePhoto",
        imageFile: yukSigortaPolicesi
    }
    dispatch(adminUpdateDocumentTruck(updatedTruckDoc))
    }
  }

  const handleAracFotoOndenSuruculuSubmit = () => {
      if(aracFotoOndenSuruculu){
        const updatedTruckDoc = {
          userName: selectAdminArac.truckPlateNumber,
          documentType: "AracFotoOndenSuruculu",
          imageFile: aracFotoOndenSuruculu
      }
      dispatch(adminUpdateDocumentTruck(updatedTruckDoc))
      }
  }

  const handleAracFotoOndenSubmit = () => {
      if(aracFotoOnden){
        const updatedTruckDoc = {
          userName: selectAdminArac.truckPlateNumber,
          documentType: "Photo1",
          imageFile: aracFotoOnden
      }
      dispatch(adminUpdateDocumentTruck(updatedTruckDoc))
      }
  }

  const handleAracFotoYandanSubmit = () => {
      if(aracFotoYandan){
        const updatedTruckDoc = {
          userName: selectAdminArac.truckPlateNumber,
          documentType: "Photo2",
          imageFile: aracFotoYandan
      }
      dispatch(adminUpdateDocumentTruck(updatedTruckDoc))
      }
  }

  const handleAracFotoArkadanSubmit = () => {
      if(aracFotoArkadan){
        const updatedTruckDoc = {
          userName: selectAdminArac.truckPlateNumber,
          documentType: "Photo3",
          imageFile: aracFotoArkadan
      }
      dispatch(adminUpdateDocumentTruck(updatedTruckDoc))
      }
  }

  return (
    <Container onClick={() => dispatch(showModal(null))}>
      <div className="modal" onClick={(e) => e.stopPropagation()}>
        <PageTopTitle title={"Araç Belgeleri"} />
        <div className="content">
            <h3>Plaka: {selectAdminArac?.truckPlateNumber}</h3>
            <div className="belge-list">
              <div className="belge-item">
                <div className="belge-top">Ruhsat</div>
                {/* <img src={(ruhsat && URL.createObjectURL(ruhsat)) || (adminTruckDocs?.ruhsatPhoto ? `${url}${adminTruckDocs?.ruhsatPhoto}` : question)} className="belge-img" alt="kimlik" /> */}
                <img src={(ruhsat && URL.createObjectURL(ruhsat)) ? URL.createObjectURL(ruhsat) : adminTruckDocs?.ruhsatPhoto ? `${url}${adminTruckDocs?.ruhsatPhoto}`: question} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="ruhsat">Belge Seç</label>
                    <div className="file-name">{ruhsat.name || "Belge Seçin"}</div>
                    <input type="file" id="ruhsat" className='file-input' onChange={(e) => setRuhsat(e.target.files[0])} />
                    {
                        ruhsat &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleRuhsatSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

              <div className="belge-item">
                <div className="belge-top">Taşıt Kartı</div>
                <img src={(tasitKarti && URL.createObjectURL(tasitKarti)) || (adminTruckDocs?.tasitKartiPhoto ? `${url}${adminTruckDocs?.tasitKartiPhoto}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="tasitKarti">Belge Seç</label>
                    <div className="file-name">{tasitKarti.name || "Belge Seçin"}</div>
                    <input type="file" id="tasitKarti" className='file-input' onChange={(e) => setTasitKarti(e.target.files[0])} />
                    {
                        tasitKarti &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleTasitKartiSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

              <div className="belge-item">
                <div className="belge-top">Şase Fotoğrafı</div>
                <img src={(saseFoto && URL.createObjectURL(saseFoto)) || (adminTruckDocs?.sasePhoto ? `${url}${adminTruckDocs?.sasePhoto}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="saseFoto">Belge Seç</label>
                    <div className="file-name">{saseFoto.name || "Belge Seçin"}</div>
                    <input type="file" id="saseFoto" className='file-input' onChange={(e) => setSaseFoto(e.target.files[0])} />
                    {
                        saseFoto &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleSaseFotoSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

              <div className="belge-item">
                <div className="belge-top">Trafik Sigorta Poliçesi</div>
                <img src={(trafikSigortaPolicesi && URL.createObjectURL(trafikSigortaPolicesi)) || (adminTruckDocs?.trafikSigortaPolicePohoto ? `${url}${adminTruckDocs?.trafikSigortaPolicePohoto}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="trafikSigortaPolicesi">Belge Seç</label>
                    <div className="file-name">{trafikSigortaPolicesi.name || "Belge Seçin"}</div>
                    <input type="file" id="trafikSigortaPolicesi" className='file-input' onChange={(e) => setTrafikSigortaPolicesi(e.target.files[0])} />
                    {
                        trafikSigortaPolicesi &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleTrafikSigortaPolicesiSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

              <div className="belge-item">
                <div className="belge-top">Yük Sigorta Poliçesi</div>
                <img src={(yukSigortaPolicesi && URL.createObjectURL(yukSigortaPolicesi)) || (adminTruckDocs?.yukSigortaPolicePhoto ? `${url}${adminTruckDocs?.yukSigortaPolicePhoto}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="yukSigortaPolicesi">Belge Seç</label>
                    <div className="file-name">{yukSigortaPolicesi.name || "Belge Seçin"}</div>
                    <input type="file" id="yukSigortaPolicesi" className='file-input' onChange={(e) => setYukSigortaPolicesi(e.target.files[0])} />
                    {
                        yukSigortaPolicesi &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleYukSigortaPolicesiSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

              <div className="belge-item">
                <div className="belge-top">Araç Fotoğrafı Önden Sürücülü</div>
                <img src={(aracFotoOndenSuruculu && URL.createObjectURL(aracFotoOndenSuruculu)) || (adminTruckDocs?.aracFotoOndenSuruculu ? `${url}${adminTruckDocs?.aracFotoOndenSuruculu}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="aracFotoOndenSuruculu">Belge Seç</label>
                    <div className="file-name">{aracFotoOndenSuruculu.name || "Belge Seçin"}</div>
                    <input type="file" id="aracFotoOndenSuruculu" className='file-input' onChange={(e) => setAracFotoOndenSuruculu(e.target.files[0])} />
                    {
                        aracFotoOndenSuruculu &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleAracFotoOndenSuruculuSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

              <div className="belge-item">
                <div className="belge-top">Araç Fotoğrafı Önden</div>
                <img src={(aracFotoOnden && URL.createObjectURL(aracFotoOnden)) || (adminTruckDocs?.photo1 ? `${url}${adminTruckDocs?.photo1}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="aracFotoOnden">Belge Seç</label>
                    <div className="file-name">{aracFotoOnden.name || "Belge Seçin"}</div>
                    <input type="file" id="aracFotoOnden" className='file-input' onChange={(e) => setAracFotoOnden(e.target.files[0])} />
                    {
                        aracFotoOnden &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleAracFotoOndenSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

              <div className="belge-item">
                <div className="belge-top">Araç Fotoğrafı Yandan</div>
                <img src={(aracFotoYandan && URL.createObjectURL(aracFotoYandan)) || (adminTruckDocs?.photo2 ? `${url}${adminTruckDocs?.photo2}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="aracFotoYandan">Belge Seç</label>
                    <div className="file-name">{aracFotoYandan.name || "Belge Seçin"}</div>
                    <input type="file" id="aracFotoYandan" className='file-input' onChange={(e) => setAracFotoYandan(e.target.files[0])} />
                    {
                        aracFotoYandan &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleAracFotoYandanSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

              <div className="belge-item">
                <div className="belge-top">Araç Fotoğrafı Arkadan</div>
                <img src={(aracFotoArkadan && URL.createObjectURL(aracFotoArkadan)) || (adminTruckDocs?.photo3 ? `${url}${adminTruckDocs?.photo3}` : question)} className="belge-img" alt="kimlik" />
                <div className="belge-bottom">
                    <label className="file-input-label" htmlFor="aracFotoArkadan">Belge Seç</label>
                    <div className="file-name">{aracFotoArkadan.name || "Belge Seçin"}</div>
                    <input type="file" id="aracFotoArkadan" className='file-input' onChange={(e) => setAracFotoArkadan(e.target.files[0])} />
                    {
                        aracFotoArkadan &&
                        <Button bgColor="transparent" color="#E85446" padding="0 10px" handleClick={handleAracFotoArkadanSubmit}>Belge Ekle</Button>
                    }
                </div>
              </div>

            </div>
            
        </div>
        <div className="btn">
          <Button width="150px" handleClick={() => dispatch(showModal(null))} padding="10px" bgColor="#E85446" color={"#fff"}>
            Kapat
          </Button>
        </div>
      </div>
    </Container>
  );
};

export default AdminAraclarBelgeIslemler;
